import styled from "styled-components";

export const MiddleBlockSection = styled("section")`
  position: relative;
  padding: 6rem 0 0rem;
  text-align: center;
  display: flex;
  justify-content: center;

  @media screen and (max-width: 1024px) {
    padding: 5.5rem 0 0rem;
  }
`;

export const ContentQuestion = styled("div")`
  font-family: 'Gilroy Semibold', serif;
  color: #2A3273;
  text-align: left;
  font-size: 22px;

  @media screen and (max-width: 768px) {
    font-size: 20px;
  }

  @media screen and (max-width: 480px) {
    font-size: 18px;
  }
`;

export const ContentText = styled("div")`
  font-family: 'Gilroy Light', serif;
  color: #000000;
  text-align: left;
  font-size: 16px;
  padding-top: 12px;

  @media screen and (max-width: 1024px) {
    font-size: 14px;
  }

  @media screen and (max-width: 480px) {
    font-size: 12px;
  }
`;

export const ContentTitle = styled("div")`
  text-align: left;
  margin-bottom: 1rem;
  font-family: 'Gilroy Bold', serif;
  color: #2159A6;
  font-size: 44px;
  line-height: 1.18;

  @media screen and (max-width: 1024px) {
    font-size: 38px;
  }

  @media screen and (max-width: 768px) {
    font-size: 32px;
  }

  @media screen and (max-width: 480px) {
    font-size: 26px;
  }
`;

export const SemicircleRectangle1 = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 300px;
  height: 170px;
  background-color: #2A3273;
  border-top-left-radius: 0;
  border-top-right-radius: 80px;
  border-bottom-right-radius: 80px;
  border-bottom-left-radius: 0;


  @media screen and (max-width: 1024px) {
    width: 260px;
    height: 150px;
  }

  @media screen and (max-width: 768px) {
    width: 240px;
    height: 140px;
  }

  @media screen and (max-width: 480px) {
    width: 150px;
    height: 90px;
  }

`;

export const SemicircleRectangle2 = styled.div`
  width: 200px;
  height: 150px;
  background-color: #2A3273;
  border-top-left-radius: 100px;
  border-top-right-radius: 100px;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;

  @media screen and (max-width: 1024px) {
    width: 120px;
    height: 80px;
  }
`;

export const ContentWrapper = styled("div")`
  display: flex;
  flex-wrap: nowrap;  /* Prevent stacking/wrapping */
  justify-content: space-between;
  align-items: flex-start;
  max-width: 1140px;
  width: 100%;

  & > .left-column,
  & > .right-column {
    flex: 1 1 50%;
    min-width: 0; /* Prevent overflow */
  }
`;

export const RightColumnContent = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const BottomRightAligned = styled.div`
  margin-top: auto;
  align-self: flex-end;
  padding-top: 20px;
`;

export const StyledImage = styled.img`
  position: absolute;
  top: 75%;
  left: 35%;
  transform: translate(-50%, -50%);
  width: 100%;
  max-width: 280px;
  height: auto;
  border-radius: 12px;

  @media screen and (max-width: 1024px) {
    max-width: 240px;
    top: 63%;
    left: 45%;
  }

  @media screen and (max-width: 768px) {
    max-width: 230px;
    top: 60%;
    left: 45%;
  }

  @media screen and (max-width: 480px) {
    max-width: 140px;
    height: 360px;
    top: 63%;
    left: 50%;
  }
`;

export const OverlayWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 300px;
  margin: 0 auto;

  @media screen and (max-width: 1024px) {
    height: 310px;
  }
`;
